'use client';

import { createContext, ReactNode, useContext, useState } from 'react';

type Values = {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

const ProductInformationContext = createContext<Values>({
  isModalOpen: false,
  openModal: () => {},
  closeModal: () => {}
});

export const ProductInformationProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <ProductInformationContext.Provider
      value={{
        isModalOpen: isOpen,
        openModal: () => setOpen(true),
        closeModal: () => setOpen(false)
      }}
    >
      {children}
    </ProductInformationContext.Provider>
  );
};

export const useProductInformation = (): Values => {
  const context = useContext(ProductInformationContext);

  return context;
};
